import { render, staticRenderFns } from "./step0.vue?vue&type=template&id=3c2d0706&scoped=true&"
import script from "./step0.vue?vue&type=script&lang=js&"
export * from "./step0.vue?vue&type=script&lang=js&"
import style0 from "./step0.vue?vue&type=style&index=0&id=3c2d0706&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d0706",
  null
  
)

export default component.exports